import image1 from '@/assets/images/news/detail/20201022/1.png';
import image2 from '@/assets/images/news/detail/20201022/2.jpg';
import image3 from '@/assets/images/news/detail/20201022/3.jpg';
import image4 from '@/assets/images/news/detail/20201022/4.jpg';
import image5 from '@/assets/images/news/detail/20201022/5.png';
import image6 from '@/assets/images/news/detail/20201022/6.jpg';
import image7 from '@/assets/images/news/detail/20201022/7.jpg';
import image8 from '@/assets/images/news/detail/20201022/8.jpg';
import image9 from '@/assets/images/news/detail/20201022/9.jpg';

export default {
  id: '20201022', //  模块 id
  title: '发现属于叮咚的美 | 叮咚买菜首届员工摄影大赛评选结果新鲜出炉！', // 标题
  origin: '摘要：进来看看你获奖了没？', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: 0,
      text:
        '为期近1个月的叮咚买菜首届员工摄影大赛，即将落下帷幕啦！摄影大赛活动发布之后，我们收到了来自各个事业部、大仓及总部小伙伴们的踊跃投稿。主办方从投稿作品的清晰度、镜头感、故事性等角度综合评估，选出符合参赛要求的20幅摄影作品进入投票环节。10月21日投票截止后，我们一共收到了1058次线上投票，小伙伴都为自己喜欢的参赛作品投票点赞！',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 1,
      title: '',
      src: [image2, image3, image4],
    },
    {
      type: 1,
      title: '',
      src: [image5],
    },
    {
      type: 1,
      title: '',
      src: [image6, image7],
    },
    {
      type: 1,
      title: '',
      src: [image8, image9],
    },
    {
      type: 0,
      text: '入围投票环节的其他参赛小伙伴，将获得叮咚纪念相框摆台1份：',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '乐薇（广东事业部）、周婧（行政效能部）、李坤成（上海事业部）、高伟（上海事业部）、沈奚（防损中心）、卞人劼（市场部）、王硕（浙江城市分选中心）、陈栋（上海事业部）、熊灿（广东事业部）、吴杰勇（广东事业部）',
      isIndent: false,
    },
    {
      type: 0,
      text: '恭喜以上获奖的小伙伴！请关注后续奖品发放通知哦~',
      isIndent: false,
    },
    {
      type: 0,
      text: '没有获奖的小伙伴也不要灰心，未来将有更多机会等着你！',
      isIndent: false,
    },
    {
      type: 0,
      text: '细节之处见真知，',
      isIndent: false,
    },
    {
      type: 0,
      text: '细微之处见品质。',
      isIndent: false,
    },
    {
      type: 0,
      text: '善于发现美好的人、事、景，',
      isIndent: false,
    },
    {
      type: 0,
      text: '让他们成为我们前行的动力和榜样，',
      isIndent: false,
    },
    {
      type: 0,
      text: '让美丽的风景荡涤我们的心灵。',
      isIndent: false,
    },
    {
      type: 0,
      text: '叮咚文化传播，有你有我有大家！',
      isIndent: false,
    },
    {
      type: 0,
      text: '策划编辑：行政效能部',
      isIndent: false,
    },
  ],
};
